import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export const Header = ({ isEdit }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex flex-row justify-between px-40 font-bold text-primary text-[18px]">
      <div
        className="flex justify-center items-center"
        onClick={() => navigate(-1)}
      >
        <svg
          className="w-7 text-primary"
          fill="none"
          stroke="currentColor"
          strokeWidth={1.5}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15.75 19.5L8.25 12l7.5-7.5"
          />
        </svg>
        {/* <p>العودة إلى القائمة</p> */}
        <p>
          {t("common.back_to_list")}
        </p>
      </div>
      <div className="text-black">{isEdit ? t("common.edit") : t("common.add")}</div>
    </div>
  );
};